import React from "react";
import Utils from "../../utility/utility";
import { STRING } from "../../constants/string";

/**
 * What a logged day is worth, shared by the two timelog screens so the admin
 * listing and the developer's own listing can never disagree about which day
 * is short.
 *
 * `state` is the word, `tone` is the row wash - one entry per state, so a tone
 * cannot drift from the caption that explains it.
 *
 * The old markup had a fifth branch: `end_time == ''` painted its own colour
 * with no legend entry beside it. A day with no checkout IS a day that was not
 * clocked out, so the two collapse here and the legend becomes true.
 */
export const DAY_STATES = [
  { state: "Completed", tone: "success" },
  { state: "Not completed", tone: "danger" },
  { state: "Not clocked out", tone: "info" },
  { state: "Saturday", tone: "attention" },
];

export const TONE_BY_STATE = DAY_STATES.reduce(
  (map, entry) => ({ ...map, [entry.state]: entry.tone }),
  {}
);

/* Saturday is checked first because a Saturday worked short is still filed as
   weekend work rather than as a missed day - which is what the original
   ternary did, and what the legend implies. */
export const dayState = (log) => {
  if (log?.isSaturday) return "Saturday";
  if (log?.is_clockout == "1" || !log?.end_time) return "Not clocked out";
  return Utils.momentHours(log?.productive_time) < 9
    ? "Not completed"
    : "Completed";
};

export const dayTone = (log) => TONE_BY_STATE[dayState(log)] ?? null;

export const clockTime = (timestamp) =>
  timestamp
    ? Utils.momentTimeFromTimestamp(STRING.PROJECT_TIME_FORMAT, timestamp)
    : "NA";

/** Names the four row washes, in the order the states escalate. */
export const ToneLegend = () => (
  <div className="dt-legend">
    {DAY_STATES.map((entry) => (
      <span className="dt-legend-item" key={entry.state}>
        <span
          className={"dt-key dt-key-" + entry.tone}
          aria-hidden="true"
        ></span>
        {entry.state}
      </span>
    ))}
  </div>
);
